import React, { useState } from 'react';
import { PageInteractionsPrintPageForm, PagePrintTreeForm } from './PageInteractionsPrintPageForm';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { Button } from '../../../../components/molecules/Btn/Button';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { BtnModifier } from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';

export function PageInteractionsPrintButton({ printTree }: { printTree: PagePrintTreeForm }) {
  const { t } = useSonTranslation('PageInteractions');
  const title = t(`print.buttonTitleText`);
  const { headMetaInfo } = useAppContext();
  const [openPrintPageModal, setOpenPrintPageModal] = useState<boolean>(false);

  // only published pages are considered in the /baumdruck/ print version
  // so if a user is on a non published page we open the browser default print mode
  const printableWithForm = headMetaInfo.versionState === 'published';

  return (
    <>
      <div className="page-interactions__button-container">
        <Button
          type="button"
          title={title}
          tooltipPlacement={TooltipPlacement.TOP}
          hideTooltipFromScreenReader
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          onClick={() => {
            if (printableWithForm) {
              setOpenPrintPageModal(true);
            } else {
              window.print();
            }
          }}
        >
          <Button.Icon svgSpriteId={Icons.PRINTER} text={title} />
        </Button>
      </div>
      {openPrintPageModal && (
        <PageInteractionsPrintPageForm closeModal={() => setOpenPrintPageModal(false)} printTree={printTree} />
      )}
    </>
  );
}
